import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/es/integration/react";
import { store, persistor } from "./configs/store";
import { Provider as ProviderRedux } from "react-redux";
import ReduxIntlProvider from "./components/ReduxProviders";
import ToastContainer from "./components/ToastContainer";
import * as serviceWorker from "./serviceWorker";
import "@masterteam/mt-design-react/lib/theme.css";
import "./index.scss";
import "./assets/scss/_animate.scss";
import "./providers/config/httpServiceConfig";
import App from "./components/App";
import ScrollToTop from "./components/ScrollToTop";

const root = createRoot(document.getElementById("root"));
root.render(
  <ProviderRedux store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ReduxIntlProvider>
        <HashRouter>
          <ScrollToTop />
          <App />
          <ToastContainer />
        </HashRouter>
      </ReduxIntlProvider>
    </PersistGate>
  </ProviderRedux>
);

serviceWorker.unregister();
